import { useSyncExternalStore } from 'react'

const subscribe = () => () => {}

/**
 * Returns false during SSR and the first client render, true after hydration.
 * useSyncExternalStore keeps the server snapshot (false) and client snapshot
 * (true) consistent without a setState-in-effect cascade. Date formatting relies
 * on this to defer the browser timezone until after hydration. OCE-1226.
 */
export function useIsHydrated(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => true,
    () => false
  )
}
